import React, { Component } from 'react';
import { connect } from "react-redux";
import ProfileCell from '../Pages/Stakeholder/User/ProfileCell';

import axios from "axios";
import moment from "moment";
import ApproveRejectComponent from './ApproveRejectComponent.jsx';
import { VCIcon, DivisionIcon } from '../Common/Buttons/TypeIcons.js';
import { Trans } from 'react-i18next';

//A React component will allow us to quickly iterate and change our code. It provides 
class UserRequestRow extends Component {
    constructor(props) {
        super(props);

        this.generateTitle = this.generateTitle.bind(this);
        this.openRequest = this.openRequest.bind(this);

        this.state = {
        };
    }

    componentDidMount() {
    }

    componentWillReceiveProps(nextProps) {
    }

    generateTitle() {
        var job = ""

        if (this.props.invite.Title !== null) {
            job = ", " + this.props.invite.Title
        }

        if (this.props.invite.Company !== null) {
            if (job === "") {
                job = ", " + this.props.invite.Company
            } else {
                job = job + " at " + this.props.invite.Company
            }
        }

        return job;
    }

    openRequest() {
        const element = document.getElementById(this.props.datatoggle);
        if (!element) return;

        element.classList.toggle('is-open');

        const base_url = (this.props.match.url).split('/')[1]
        this.props.history.push("/" + base_url + '/profile/' + this.props.invite.ID + '/Overview')
    }

    renderRequestsIcons() {
        // Grouping request stakeholders by vmh.
        const requests = this.props.invite.sh_requests.reduce((acc, request) => ({
            ...acc,
            [request.VMH_ID]: {
                vmh: request.vmh,
                stakeholders: acc[request.VMH_ID] ? [...acc[request.VMH_ID].stakeholders, request.stakeholder] : [request.stakeholder]
            }
        }), {});

        return (
            <div className="float-left">
                {Object.values(requests).map((request) => (
                    <div style={{ padding: '8px 6px' }}>
                        {VCIcon(request.vmh, undefined, undefined, undefined, true)}
                        {request.stakeholders.map((stakeholder) =>
                            DivisionIcon(stakeholder, undefined, undefined, undefined, true)
                        )}
                    </div>
                ))}
            </div>
        );
    }

    render() {
        return (
            <div className = "alert-row clickable-row">
                <div className="float-left request-info" onClick={this.openRequest}>
                    <span className = "medium">{this.props.invite.First_Name} {this.props.invite.Last_Name}</span>{this.generateTitle()}
                    <div className = "clearfix"></div>
                    <span className = "caption"><Trans>Requested on</Trans> { moment(this.props.invite.sh_requests[0].Created_At).format("MMM DD, YYYY")}</span>
                    <div className = "clearfix mb-8"></div>
                </div>

                {this.renderRequestsIcons()}

                {
                    this.props.invite.has_authorizing ? 
                        <div className="alert-actions">
                            <ApproveRejectComponent match={this.props.match} history={this.props.history} datatoggle={this.props.datatoggle} type="user" id={this.props.invite.ID} />
                        </div>
                    :
                        <span />
                }
                <div className = "clearfix"></div>
            </div>
        )
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession
});

export default connect(mapStateToProps)(UserRequestRow);